import { Injectable, ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  /**
   * Handles the application errors
   * @param error of any type that is thrwon by the application
   */
  handleError(error: any): void {
    Sentry.captureException(error);
  }
}
